<template>

    <main id="main-content" role="main">

        <div class="flex">
            <div class="flex-1 mb-4 text-2xl font-medium text-gray-900 capitalize">
                <h1>Reports</h1>
            </div>

            <button type="button" class="btn text-sm ml-4" @click.prevent="createSchedule">
                Create Schedule
            </button>

            <router-link :to="{ name: 'report.create' }" class="btn text-sm ml-4" v-if="isAdmin">Create New Report</router-link>
        </div>

        <div>
            <div class="filter-bar">
                <ul class="grid-cols-5">
                    <li>
                        <button :class="{ 'active': section === 'index' }" @click="viewTabbedSection('index')">
                            Reports
                        </button>
                    </li>
                    <li>
                        <button :class="{ 'active': section === 'render' }" @click="viewTabbedSection('render')">
                            Render
                        </button>
                    </li>
                    <li>
                        <button :class="{ 'active': section === 'pending' }" @click="viewTabbedSection('pending')">
                            Pending
                        </button>
                    </li>
                    <li>
                        <button :class="{ 'active': section === 'complete' }" @click="viewTabbedSection('complete')">
                            Complete
                        </button>
                    </li>
                    <li>
                        <button :class="{ 'active': section === 'schedule' }" @click="viewTabbedSection('schedule')">
                            Schedule
                        </button>
                    </li>
                </ul>
                <div class="filters grid-cols-6">
                    <div class="filter-control col-span-6 xl:col-span-2">
                        &nbsp;
                    </div>
                </div>
            </div>

            <div v-if="loaded">

                <ReportIndex v-if="sectionIs('index')" @showReport="showReport"></ReportIndex>

                <ReportRender v-if="sectionIs('render')" :id="id" @showReport="showReport" @showReportIndex="showReportIndex" @showPendingReports="showPendingReports"></ReportRender>

                <ReportPending v-if="sectionIs('pending')" @showCompleteReports="showCompleteReports"></ReportPending>

                <ReportComplete v-if="sectionIs('complete')" @showReportIndex="showReportIndex"></ReportComplete>

                <ReportSchedule v-if="sectionIs('schedule')" @showCompleteReports="showCompleteReports" @createSchedule="createSchedule"></ReportSchedule>

            </div>
            <Loading message="Loading Reports" v-else></Loading>
        </div>

    </main>

</template>

<script>
import Loading from "../Support/Loading";
import ReportIndex from "./ReportIndex";
import ReportRender from "./ReportRender";
import ReportPending from "./ReportPending";
import ReportComplete from "./ReportComplete";
import ReportSchedule from "./ReportSchedule";

export default {
    name: "Report",
    data() {
        return {
            id: null,
            section: 'index',
            loaded: false,
        }
    },
    components: {
        ReportIndex,
        ReportRender,
        ReportPending,
        ReportComplete,
        ReportSchedule,
        Loading
    },
    computed: {
        isAdmin() {
            return this.$parent.isAdmin;
        }
    },
    methods: {
        createSchedule() {
            this.$router.push({ name: 'report.schedule.create' });
        },
        showReportIndex() {
            this.viewTabbedSection('index')
        },
        showReport(payload) {
            this.viewTabbedSection('render', payload.id)
        },
        showPendingReports() {
            this.viewTabbedSection('pending');
        },
        showCompleteReports() {
            this.viewTabbedSection('complete');
        },
        sectionIs(section) {
            return this.section === section;
        },
        viewTabbedSection(section, id = null) {
            this.section = section;

            if (id) {
                this.id = id;
            }
        },
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            resolve(true);
        }).then(r => {
            vm.loaded = r;
        });
    }
}
</script>
